import { memo } from 'react';
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from 'react-router-dom';
import { Security } from 'security';
import {
  SignIn,
  SignUp,
  Login,
  Step1CompalteProfile,
  Step2CompalteProfile,
  Step3CompalteProfile,
  Step4CompalteProfile,
  Container,
  ProfileStatus,
} from 'pages';
import { ROUTE } from './data';
import PageNotFound from 'pages/notFound';

const Routers = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Security direction="backward" />}>
          <Route path={ROUTE.login} element={<Login />} />
          <Route path={ROUTE.signUp} element={<SignUp />} />
          <Route path={ROUTE.signIn} element={<SignIn />} />
          <Route path={'/'} element={<Navigate to={ROUTE.login} />} />
        </Route>

        <Route path="/" element={<Security direction="forward" />}>
          <Route path={ROUTE.profileStatus} element={<ProfileStatus />} />
          <Route path={ROUTE.complateProfileRoot} element={<Container />}>
            <Route
              path={ROUTE.complateProfileStep1}
              element={<Step1CompalteProfile />}
            />
            <Route
              path={ROUTE.complateProfileStep2}
              element={<Step2CompalteProfile />}
            />
            <Route
              path={ROUTE.complateProfileStep3}
              element={<Step3CompalteProfile />}
            />
            <Route
              path={ROUTE.complateProfileStep4}
              element={<Step4CompalteProfile />}
            />
          </Route>
        </Route>

        <Route key="not-found" path="*" element={<PageNotFound />} />
      </Routes>
    </Router>
  );
};

export default memo(Routers);
